export const PROMOTION_STATUS = {
  PENDING: 'STATUS_PENDING',
  ACCEPTED: 'STATUS_ACCEPTED',
  CANCELED: 'STATUS_CANCELED',
  EXPIRED: 'STATUS_EXPIRED'
};

export const PROMOTION_TYPES = {
  DISCOUNT: 'DISCOUNT',
  FREE_MENU: 'MENU',
  DRINK: 'DRINK',
  TAKE_AWAY_DISCOUNT: 'TA_DISCOUNT',
  TAKE_AWAY_MENU: 'TA_MENU',
  LOYALTY: 'LOYALTY',
  LOYALTY_DRINK: 'LOYALTY_DRINK',
  PREPAID_VOUCHER: 'PREPAID_VOUCHER',
  SOLIDARY: 'SOLIDARY',
  REMOTE_INVITATION: 'REMOTE_INVITATION',
};

export const PROMOTION_GROUP = {
  MENU: [PROMOTION_TYPES.DRINK, PROMOTION_TYPES.FREE_MENU, PROMOTION_TYPES.DISCOUNT],
  TAKE_AWAY: [PROMOTION_TYPES.TAKE_AWAY_DISCOUNT, PROMOTION_TYPES.TAKE_AWAY_MENU],
  LOYALTY: [PROMOTION_TYPES.LOYALTY, PROMOTION_TYPES.LOYALTY_DRINK],
  PREPAID: [PROMOTION_TYPES.PREPAID_VOUCHER, PROMOTION_TYPES.SOLIDARY, PROMOTION_TYPES.REMOTE_INVITATION],
};

export const PROMOTION_ERRORS = {
  OWNED: 'booking.user.maximumcatalog.invalid',
  DAILY_LIMIT: 'booking.user.maximumdaily.invalid',
  LIMIT: 'booking.promotion.limit.invalid',
  WRONG_DAY: 'booking.promotion.repeat.invalid',
  GLOBAL_LIMIT: 'booking.global.limit.invalid',
  DISABLED: 'booking.promotion.enabled.invalid'
};

export const REWARD_ERRORS = {
  NOT_ENOUGH: 'bookingreward.user.points.notMatch'
};

export const LOYALTY_CARD_ERRORS = {
  MAXIMUM: 'booking.loyaltycards.maximum.invalid',
  EXPIRED: 'booking.loyaltycards.expired.invalid',
  EXPIRED_REWARD: 'booking.loyaltycards.expiredreward.invalid'
};
